import { Outlet } from "react-router-dom";

import { SecondaryNavigation } from "@/components/secondary-navigation";
import { NavigationGroup } from "@/types/navigation";
import { useTranslation } from "react-i18next";

export function AdvertisementsLayout() {
  const { t } = useTranslation();

  const navigation: NavigationGroup[] = [
    {
      elements: [
        { name: t("nav.splashAdvertisement"), href: `/advertisements/splash` },
      ],
    },
  ];
  return (
    <div>
      <div className="grid grid-cols-12 gap-x-8">
        <div className="col-span-12 mb-4 md:block lg:col-span-3">
          <SecondaryNavigation navigations={navigation} />
        </div>
        <div className="col-span-12 lg:col-span-9">
          <Outlet />
        </div>
      </div>
    </div>
  );
}